import React from 'react';
import ReactDOM from 'react-dom';
import ErrorPage from './components/ErrorPage/ErrorPage';
import { getParam, validateParams } from './util/parameterParser';

import { connectors, setAuthTokenForPVA } from './bridge/bridge';
import { LoadScript } from './components/LoadScript';
import {
  ACCESS_TOKEN,
  BANK_ID,
  APP_ID,
  DEVICE_ID,
  ACCOUNT_ID,
  CUSTOM_CONTEXT,
  OUTBOUND_CONTEXT,
  OUTBOUND_CONTEXT_VARIABLES
} from './util/Constants';

// Start the mocking conditionally.
if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./mocks/browser');
  worker.start();
}

const startApp = () => {
  try {
    window.urlParams = {
      bankId: getParam(BANK_ID) || 'CB',
      accessTokenFromClient: getParam(ACCESS_TOKEN),
      customContext: getParam(CUSTOM_CONTEXT),
      // Cards Parameters
      deviceId: getParam(DEVICE_ID),
      accountId: getParam(ACCOUNT_ID),
      appId: getParam(APP_ID),
      outboundContext: getParam(OUTBOUND_CONTEXT),
      outboundContextVariables: getParam(OUTBOUND_CONTEXT_VARIABLES)
    };
    validateParams();
    setAuthTokenForPVA();
    ReactDOM.render(<LoadScript />, document.getElementById('root'));
    connectors();
  } catch (error) {
    ReactDOM.render(<ErrorPage />, document.getElementById('root'));
  }
};

startApp();

// For testing the callback on browser console
// auth.getAuthenticationToken((jwt) => {
//   console.log(`jwt response from callback: ${jwt}`);
// });
